/** Money rules (SPEC §4): integer cents, percentages as decimal text, half-up rounding. */

/** Half-up rounding to an integer (Math.round rounds -0.5 toward +∞; we want away-from-zero symmetry for negatives). */
export function roundHalfUp(n: number): number {
  return n < 0 ? -Math.round(-n) : Math.round(n);
}

/** cents × pct% (pct as text or number) with half-up rounding. */
export function pctOf(cents: number, pct: string | number): number {
  const p = typeof pct === "string" ? Number.parseFloat(pct) : pct;
  if (!Number.isFinite(p)) return 0;
  return roundHalfUp((cents * p) / 100);
}

export function formatCents(cents: number, opts: { sign?: boolean } = {}): string {
  const abs = Math.abs(cents);
  const s = `$${Math.floor(abs / 100).toLocaleString("en-US")}.${String(abs % 100).padStart(2, "0")}`;
  if (cents < 0) return `-${s}`;
  return opts.sign ? `+${s}` : s;
}

/** Parse "1,234.50" / "$1234" / "1234" into cents; null when not a number. */
export function parseCents(input: string | number | null | undefined): number | null {
  if (input === null || input === undefined) return null;
  if (typeof input === "number") return Number.isFinite(input) ? roundHalfUp(input * 100) : null;
  const cleaned = input.replace(/[$,\s]/g, "");
  if (!cleaned || !/^-?\d*(\.\d+)?$/.test(cleaned)) return null;
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? roundHalfUp(n * 100) : null;
}
